<!--
 * @Author: 夏元元 xiayuanyuan@itcast.cn
 * @Date: 2024-12-30 17:21:30
 * @LastEditors: 夏元元 xiayuanyuan@itcast.cn
 * @LastEditTime: 2025-01-02 14:19:03
 * @FilePath: \subject-topic-new\components\coursePage\pythonData\Box5.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="box5">
      <pageTitle
        title="AI+Python大数据开发<br/>工资香上升快"
        text="未来最大的能源是大数据，“懂AI”成大数据开发人才的硬实力"
        titleColor="transparent"
        titColor="#666666"
      />
      <div class="nav-box">
        <div class="nav"
          :class="{ 'cur-nav': cur == index }" 
          v-for="(item, index) in navList" 
          :key="index"
          @click="changeCur(index)">
          <p>{{item.name}}</p>
        </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in projectList"
          :key="index"
        >
          <div class="wrap">
            <img :src="item.imgUrl" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="box5-bottom">

    </div>
  </div>
</template>

<script>
import pageTitle from '../common/pageTitle.vue'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  data() {
    let that = this;
    return {
      cur: 0,
      navList: [{name: '人才需求大'},{name: '就业薪资高'},{name: '升职加薪快'}],
      swiperOption: {
        loop: true,
        slidesPerView: 1,
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
          }
        },
      },
      projectList: [
        {imgUrl: require('../../../assets/coursePage/pythonData/box5/pic2.png')},
        {imgUrl: require('../../../assets/coursePage/pythonData/box5/pic1.png')},
        {imgUrl: require('../../../assets/coursePage/pythonData/box5/pic3.png')}
      ]
    };
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index + 1, 0, false);
      this.cur = index;
    },
  }
};
</script>

<style lang="less" scoped>
.box5-bottom{
  width: 100%;
  height: 300px;
  background: url("../../../assets/coursePage/pythonData/box5.jpg") no-repeat;
  background-size: cover;
  background-position: center;

}
.box5 {
  padding: 80px 0;
  background: linear-gradient( 180deg, #FFFFFF 0%, #effaff 100%);
  border-radius: 1px;
  /deep/.course-title-box {
    padding: 0 50px;
    .course-title {
      font-family: AlibabaPuHuiTiB;
      background: linear-gradient(to right, #0078FF, #0030AA);
      /* -webkit- 前缀用于兼容性 */
      -webkit-background-clip: text;
      /* 使文字透明，背景可见 */
      color: transparent;
    }
    .course-text {
      margin-top: 14px;
      font-size: 30px;
      font-weight: 400;
      color: #666666;
      line-height: 42px;
    }
  }
  .nav-box {
    padding: 0 50px;
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .nav {
      p {
        width: 200px;
        height: 70px;
        font-size: 28px;
        line-height: 70px;
        color: #b2f7ff;
        text-align: center;
        background: #0077fd;
        border: 4px #2b9bff solid;
        border-radius: 20px;
        font-weight: bold;
        margin: 0 auto;
      }
      
    }
    .cur-nav {
      p {
        height: 86px;
        line-height: 80px;
        border: none;
        background: url("../../../assets/coursePage/pythonData/box5/tab-bg.png") no-repeat;
	      background-size: 100% 100%;
        color: #FFFFFF;
      }
    }
  }
  .swiperitems {
	  margin: 30px auto 0;
    .wrap {
      width: 650px;
      margin: 0 auto;
      img {
        width: 650px;
      }
    }
  }
}
</style>
